export const cards = [
  { title: 'Términos y Condiciones', id: 1 },
  { title: 'Políticas de Privacidad', id: 2 },
]
